import React from 'react';

const AsSeenOnSection = () => {
  return (
    <section className="bg-black py-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <p className="text-sm tracking-[0.3em] text-gray-400 uppercase">As Featured On</p>
          <h2 className="text-2xl md:text-3xl font-light text-white mt-2">The American Dream</h2>
        </div>
        <div className="flex justify-center">
          <img
            src="/images/as-seen-on.png"
            loading="lazy"
            alt="The American Dream - As Seen On Prime Video, YouTube, Tubi, Fire TV, Apple TV, Roku, CNBC, Bloomberg Television"
            width="768"
            height="292"
            className="w-full max-w-3xl h-auto"
            data-testid="american-dream-banner"
          />
        </div>
      </div>
    </section>
  );
};

export default AsSeenOnSection;
